import { combineReducers } from "redux";
import languageReducer from "./language/languageReducer";

export default combineReducers({
  languageReducer,
});
